module.exports = __webpack_public_path__ + "img/irys-big-2.766b81b4.jpg";